import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const add = "marcom/variable/add";
const getAll = "marcom/variable/getAll";
const getAllDropDown = "marcom/variable/getAllDropDown";
const getMultiple = "marcom/variable/getMultiple";
const update = "marcom/variable/update";

export default {
  add(payload) {
    return Repository.post(`${add}`, payload);
  },
  update(payload) {
    return Repository.post(`${update}`, payload);
  },
  getAll(payload) {
    return Repository.post(`${getAll}`, payload);
  },
  getAllDropDown(payload) {
    return Repository.post(`${getAllDropDown}`, payload);
  },
  getMultiple(payload) {
    return Repository.post(`${getMultiple}`, payload);
  },
};
